// This icon file is generated automatically.
var PRiseOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.33 2.3l-3.11.37a.13.13 0 00-.08.22l.93.92-3.53 3.53-1.6-1.59a.25.25 0 00-.35 0L.57 10.78a.13.13 0 000 .18l.7.7c.05.05.13.05.18 0l4.32-4.32 1.59 1.6c.1.09.26.09.35 0l4.24-4.24.93.92c.07.08.2.03.21-.07l.38-3.11a.12.12 0 00-.14-.14z", "fill-rule": "nonzero" } }] }, "name": "p-rise", "theme": "outlined" };
export default PRiseOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PRiseOutlined.js
// module id = 3598
// module chunks = 0